package co.maytes.standupbot.dashboard.features.setup

import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import co.maytes.standupbot.dashboard.components.widgets.Button
import co.maytes.standupbot.dashboard.components.widgets.ButtonSize
import co.maytes.standupbot.dashboard.components.widgets.ButtonVariant
import co.maytes.standupbot.dashboard.components.widgets.ControlSize
import co.maytes.standupbot.dashboard.components.widgets.IconButton
import co.maytes.standupbot.dashboard.components.widgets.cssRgb
import co.maytes.standupbot.dashboard.components.widgets.icons.LucideX
import co.maytes.standupbot.dashboard.features.settings.IntegrationsCopy
import co.maytes.standupbot.dashboard.stores.rememberAuthStore
import co.maytes.standupbot.dashboard.stores.rememberSetupStatusStore
import co.maytes.standupbot.dashboard.styles.Palette
import co.maytes.standupbot.dashboard.styles.Radius
import co.maytes.standupbot.dashboard.styles.Spacing
import co.maytes.standupbot.dashboard.styles.Typography
import co.maytes.standupbot.shared.design.StatusHue
import co.maytes.standupbot.shared.dto.setup.reconnectNotices
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.browser.window
import kotlinx.coroutines.launch

@Composable
fun ReconnectBanner() {
    val auth = rememberAuthStore()
    val store = rememberSetupStatusStore()
    val ctx = rememberPageContext()
    val launcher = rememberReconnectLauncher()
    val scope = rememberCoroutineScope()
    if (!store.state.showsBanner(auth.isAdmin)) return
    val danger = Palette.status(StatusHue.Danger)
    Column(modifier = Modifier.fillMaxWidth().margin(bottom = Spacing.md).gap(Spacing.xs)) {
        store.state.status?.reconnectNotices().orEmpty().forEach { notice ->
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .gap(Spacing.sm)
                    .borderRadius(Radius.md)
                    .padding(topBottom = Spacing.xs, leftRight = Spacing.md)
                    .styleModifier {
                        property("background", danger.subtle.cssRgb())
                        property("border", "1px solid ${danger.border.cssRgb()}")
                        property("flex-wrap", "wrap")
                    },
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween,
            ) {
                SpanText(
                    text = "${notice.headline} ${notice.consequence}",
                    modifier = Modifier
                        .fontSize(Typography.bodySmall.size)
                        .color(danger.onSubtle)
                        .styleModifier { property("flex", "1 1 60%"); property("min-width", "0") },
                )
                notice.fix?.let { fix ->
                    Button(
                        label = fix.label,
                        variant = ButtonVariant.Secondary,
                        size = ButtonSize.Sm,
                        onClick = {
                            val workspaceId = auth.currentUser?.workspace?.id ?: return@Button
                            scope.launch {
                                launcher.launch(
                                    provider = notice.provider,
                                    workspaceId = workspaceId,
                                    providerName = IntegrationsCopy.displayName(notice.provider),
                                    returnTo = ReconnectRoutes.returnPathFor(window.location.pathname),
                                    navigate = { path -> ctx.router.navigateTo(path) },
                                )
                            }
                        },
                    )
                }
                IconButton(
                    ariaLabel = "Dismiss",
                    size = ControlSize.Sm,
                    onClick = { store.dismissBanner() },
                ) {
                    LucideX(size = 14, strokeColor = danger.onSubtle.cssRgb())
                }
            }
        }
    }
}
